import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import { theme } from "./hoc/Theme";
import { usePageTitle } from "./hoc/Hooks";
import Footer from "./Footer";
import Header from "./Header";
import { APP_NAME } from "config";

type LayoutProps = {
  title?: string;
  content?: string;
  noScroll?: boolean;
};

const Layout = ({
  title,
  content,
  children,
  noScroll = false,
}: React.PropsWithChildren<LayoutProps>) => {
  usePageTitle(`${APP_NAME} | ` + (title || ""));

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.default",
        }}
      >
        <Header />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            pt: "88px",
            ...(noScroll && { maxHeight: "calc(100vh - 189px)" }),
            overflowY: noScroll ? "hidden" : "auto",
          }}
        >
          {children}
        </Box>

        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
